"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconURLContext = void 0;
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const useId_1 = require("../../utils/hooks/useId");
const functions_1 = require("./utils/functions");
// styles
require("./icon.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-icon",
    size: "medium",
    filled: false,
};
/**
 * Context for providing the base URL for components of type `Icon`.
 * @example
 * <IconURLContext.Provider value="/icons/url">
 *   <Icon {...props} iconName="myIcon" />
 * </IconURLContext.Provider>
 */
exports.IconURLContext = (0, react_1.createContext)("");
/**
 * Component for rendering an SVG in the virtual DOM given a URL and icon name.
 * For the icon's base URL can be either used the `src` prop or a context provider.
 * @example
 * <IconURLContext.Provider value="/icons/url">
 *   <Icon {...props} iconName="myIcon" />
 * </IconURLContext.Provider>
 */
const Icon = (_a) => {
    var { className, src, iconName, size, filled } = _a, svgProps = __rest(_a, ["className", "src", "iconName", "size", "filled"]);
    const classList = (0, classnames_1.default)("tecma-icon", { [`${size}`]: size }, className);
    let iconsURL = (0, react_1.useContext)(exports.IconURLContext);
    if (src) {
        iconsURL = src;
    }
    const completeIconName = iconName + (filled ? "-fill" : "");
    const completeIconLink = iconsURL && completeIconName && `${iconsURL}/${completeIconName}.svg`;
    const [svgElement, setSVGElement] = (0, react_1.useState)();
    const hash = (0, useId_1.useId)();
    const updateIcon = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (completeIconLink) {
            try {
                const remoteSVG = yield (0, functions_1.retrieveSVGElement)(completeIconLink, hash);
                setSVGElement(remoteSVG);
                return;
            }
            catch (error) {
                console.error(`Error while retrieving remote SVG for icon "${completeIconName}"`, (0, functions_1.getErrorMessage)(error));
            }
        }
        try {
            const localIconUrl = yield (0, functions_1.getLocalIconUrl)(completeIconName);
            const localSVG = yield (0, functions_1.retrieveSVGElement)(localIconUrl, hash);
            setSVGElement(localSVG);
        }
        catch (error) {
            setSVGElement(null);
            console.error(`Error while retrieving local SVG for icon "${completeIconName}"`, (0, functions_1.getErrorMessage)(error));
        }
    }), [completeIconLink, hash, completeIconName]);
    (0, react_1.useEffect)(() => {
        updateIcon();
    }, [iconsURL, completeIconName, updateIcon]);
    return svgElement
        ? (0, react_1.cloneElement)(svgElement, Object.assign(Object.assign({}, svgProps), { className: classList }))
        : null;
};
Icon.defaultProps = defaultProps;
exports.default = (0, react_1.memo)(Icon);
